<div class="left-box" >
  <div class="response-box">
  <div class="response-avatar">
  <img src="assets/images/mq.svg" class="icon-avatar" alt="Icon" />
  <ion-img src="assets/images/answer_settings_btn.svg" class="settings-img"  mat-button [matMenuTriggerFor]="answerSettings"></ion-img>
  <mat-menu #answerSettings="matMenu" >
    <button 
    mat-menu-item
    *ngFor="let item of settingsList"  
    class="menu-item" 
    (click)="selectSettingMode(item)"  
    [disabled]="(item=='Graph'&& graphDisabled) || (errorMessage && item!=='Sentence') || (item==='Sentence')"
    [matTooltip]="item === 'Graph' && graphDisabled ? 'Graph is not available for this data response.' : ''"
    matTooltipPosition="right" >
    <div class="select-schema">
      <ion-img [src]="'assets/images/' + item + '.svg'"></ion-img>
      <span>{{ item }}</span>
    </div>
  </button>

</mat-menu>  
  </div>
  <div *ngIf="errorMessage" class="error-message">
    <ion-text class="err-msg-text">{{errorMessage}}</ion-text>
  </div>
  
  <div class="response-container" *ngIf="results?.length && !errorMessage" [ngClass]="{'pie-mode':settingMode === 'Graph' && chartType === 'pie','graph-mode':settingMode === 'Graph' && chartType === 'bar' }">
   
    <div class="graph-container" [ngStyle]="{'background-color': filterEnabled ? '#F1D8BD':us.trainerMode?'white': '#EFEFEF'}">
      <div class="filter-cont"  >
      <div class="filter-option" (click)="openFilterMenu()">
      <ion-img src="assets/images/Control.svg" ></ion-img>
     </div>
     <div class="expand-cont" (click)="expandRows()" *ngIf="results?.length >=5">
      <ion-icon name="expand" class="expand-icon"></ion-icon>

     </div>
     </div>
    <div class="table-card " *ngIf="settingMode=='Table'">
  
      <ion-row class="table-header">
        <!-- Header Row -->
        <ion-col *ngFor="let key of getKeys(results[0])"  class="card-header">
          <span>{{ key |formatString}}</span>
        </ion-col>
      </ion-row>
      <ion-row>
      <div class="less-row-values">
      <ion-row *ngFor="let item of results">
        <ion-col *ngFor="let key of getKeys(item)"  class="card-content">
          {{ item[key] }}  <!-- Displaying item value -->
        </ion-col>
      </ion-row>
      </div>
      </ion-row>
   
    
  </div>
  

  <div class="default-canvas"  *ngIf="settingMode!=='Table'" [ngClass]="{'pie-canvas-60':chartType==='pie','label-60':!labels100 && !labels30,'label-100':labels100 && !labels30,'label-30':!labels100&& labels30 }">
  <canvas #chartCanvas   [ngClass]="{'pie-canvas':settingMode === 'Graph' && chartType === 'pie','graph-canvas-60':settingMode === 'Graph' && (chartType === 'bar' || chartType ==='line' )&& !labels100 && !labels30,'graph-canvas-100':settingMode === 'Graph' && chartType === 'bar' && labels100 &&!labels30 ,'graph-canvas-30':settingMode === 'Graph' && chartType === 'bar' && !labels100 && labels30,}">{{chart}}</canvas>
  <div class="spinner"  *ngIf="!graphDataLoaded"> <app-spinner ></app-spinner></div>
  <div class="graph-not-found" *ngIf="graphDataLoaded && graphNotFound">
    Graph not available
  </div> 
</div>
</div>
 

  <div class="space-container"></div>
  <div class="like-dislike" *ngIf="trainerMode && processType!=='EXACT_MATCH' ">
    <ion-label>Is the response correct?</ion-label>
    <ion-img [src]="'assets/images/' + likeImage + '.svg'" (click)="likeResponse()"></ion-img>
    <ion-img [src]="'assets/images/' + disLikeImage + '.svg'" (click)="disLikeResponse()"></ion-img>
  </div>
  

  </div>
  
 
  <ion-modal #modal [isOpen]="expandMore" backdropDismiss="false">
    <ng-template>
      <div class="close">
        <ion-icon name="close" class="close-icon" (click)="expandRows()"></ion-icon>
      </div>
     
      <div class="table-card  card2" *ngIf="settingMode=='Table'">
     
        <ion-row class="table-header ">
          <!-- Header Row -->
          <ion-col *ngFor="let key of getKeys(results[0])"  class="card-header">
            <span>{{ key |formatString}}</span>
          </ion-col>
        </ion-row>
        <ion-row>
        <div class="max-row-values">
        <ion-row *ngFor="let item of results">
          <ion-col *ngFor="let key of getKeys(item)"  class="card-content">
            {{ item[key] }}  <!-- Displaying item value -->
          </ion-col>
        </ion-row>
        </div>
        </ion-row>
        
    
    </div>
      <div  *ngIf="settingMode=='Graph'">
        <canvas #chartCanvas2   [ngClass]="{'pie-canvas':settingMode === 'Graph' && chartType === 'pie','graph-canvas-60':settingMode === 'Graph' && (chartType === 'bar' || chartType ==='line' )&& !labels100 && !labels30,'graph-canvas-100':settingMode === 'Graph' && chartType === 'bar' && labels100 &&!labels30 ,'graph-canvas-30':settingMode === 'Graph' && chartType === 'bar' && !labels100 && labels30,}">{{chart}}</canvas>
        
      </div>
    </ng-template>
  </ion-modal>

 </div>
 <div class="response-msg-container">
    <div *ngIf="showRightMessage" class="response-msg"   >
      <ion-progress-bar [value]="rightProgress" class="right-progress"></ion-progress-bar>
      Thanks for the correction. I’ve deleted the saved result and will reprocess your question.
    
    </div>
    <div *ngIf="showWrongMessage" class="response-msg"   >
      <ion-progress-bar [value]="wrongProgress" class="wrong-progress"></ion-progress-bar>
      {{feedbackMessage}}
     </div>
    </div>
</div>
